export default __webpack_public_path__ + "static/media/dubai-healthcare-city.1ed07574.png";